import './styles/App.scss';

import Main from './pages/Main.js';
import Header from './Components/common-header/Header.jsx';
import Footer from './Components/common-footer/Footer.jsx';
import Nav from './Components/Nav';
import Cta from './Components/Cta';

function App() {
  return (
    <div className="App">
      <Header clientName={'Range Rover'} />
      <Nav />
      <Main />
      <Cta />
      <Footer />
    </div>
  );
}

export default App;
